import React from 'react';

import './styles.css';

import NotificationCard from './NotificationCard';

import { months } from '../../../../functions/formatDate';

function NotificationsGroup(props) {
    return (
        <li className='notifications-group'>
            <h3>{props.notificationsRef ? props.notificationsRef : 'Notificações'}</h3>
            <hr />
            <ul>
                {
                    props.notificationsData ?
                        props.notificationsData.map((item, index) => {
                            const date = item.data.split('-').reverse();
                            return <NotificationCard
                                key={index}
                                tittle={item.titulo}
                                text={item.conteudo}
                                id={item.id}
                                lido={item.lido}
                                setNotifications={props.setNotifications}
                                date={`Recebido em ${date[0]} de ${months[date[1] - 1]} de ${date[2]} às ${item.hora.slice(0, 5)}`}
                            />
                        })
                        : <p>Não há notificações nesse grupo</p>
                }
            </ul>
        </li>
    )
}

export default NotificationsGroup;